export default __webpack_public_path__ + "static/media/AllProductItems10.acc31295.png";